import type { AgentRunSnapshot } from '@corner/shared';

/** Rich header for V2 query-run CoT: indexed documents + the user's prompt. */
export function formatQueryRunContextFromSnapshot(snap: Pick<AgentRunSnapshot, 'sources' | 'query'>): string | undefined {
  const parts: string[] = [];
  const names = (snap.sources ?? []).map((s) => s.name?.trim()).filter(Boolean) as string[];
  if (names.length > 0) {
    const unique = [...new Set(names)];
    parts.push(unique.length === 1 ? `Document: ${unique[0]}` : `Documents: ${unique.join(', ')}`);
  }
  const q = snap.query?.trim();
  if (q) parts.push(`Your request:\n${q}`);
  if (parts.length === 0) return undefined;
  return parts.join('\n\n');
}

/** Same shape before HTTP snapshot exists (bootstrapped from workspace session). */
export function formatQueryRunBootContext(docNames: string[], prompt: string): string | undefined {
  const parts: string[] = [];
  const unique = [...new Set(docNames.map((n) => n.trim()).filter(Boolean))];
  if (unique.length > 0) {
    parts.push(unique.length === 1 ? `Document: ${unique[0]}` : `Documents: ${unique.join(', ')}`);
  }
  const q = prompt.trim();
  if (q) parts.push(`Your request:\n${q}`);
  if (parts.length === 0) return undefined;
  return parts.join('\n\n');
}
